import runColors from "../createColors/runColors.js";
/**
 *
 * @param {lightTheme} lightTheme - lightTheme object
 * @param {darkTheme} darkTheme - darkTheme object
 * @param {string} paletteColorName - name of the palette color
 * @param {string} colorValue - value of the color
 * @returns {{light:Theme, dark:Theme}} object with light theme and dark theme
 * @description create object with light theme and dark theme for mui createTheme
 * it will setup the mode and colors automatically.
 * provide object with palette name and color.
 * use "." to separate the object and it will create object inside object
 */
const muiAddObjString = (
  lightTheme,
  darkTheme,
  paletteColorName,
  colorValue
) => {
  let pathArr = paletteColorName.split(".");
  if (pathArr.length <= 1) return null;
  const colors = runColors(colorValue);
  let lr = lightTheme.palette,
    lpr,
    dr = darkTheme.palette,
    dpr;
  for (let nm of pathArr) {
    lr[nm] = lr[nm] ? lr[nm] : {};
    lpr = lr;
    lr = lr[nm];
    dr[nm] = dr[nm] ? dr[nm] : {};
    dpr = dr;
    dr = dr[nm];
  }
  let k = pathArr[pathArr.length - 1];
  lpr[k] = colors.light;
  dpr[k] = colors.dark;
  return true;
};

export default muiAddObjString;
